export const I18N_SET_LOCALE = 'I18N_SET_LOCALE'
export const DATA_TYPE = 'JSON'
